import React, { useContext, useEffect, useState, useRef } from 'react';
import { RadioGroup } from '@progress/kendo-react-inputs';
import { LocalizationContext } from '../../../contexts';
import HeroBanner from '../heroBanner';
import Triple from '../triple';

import './index.scss';
import '../forms.scss';

export default function HeroMarketingBanner({ data, onUpdate, validator, settingsData = {}, ...rest }) {
  const emptyItem = useRef({ general_type: "", general_hero: false, general_triple: false });
  const [compData, setCompData] = useState({});
  const [contentSelect, setContentSelect] = useState(0);
  const [localization] = useContext(LocalizationContext);
  const { labels } = localization;
  const innerTabs = ['general_hero', 'general_triple'];

  validator.current = () => {
    return true;
  };

  useEffect(() => {
    const defaultData = { ...emptyItem.current };
    setCompData({ ...defaultData, ...data });
  }, [data]);

  useEffect(() => {
    setContentSelect(compData.general_type === 'hero' ? 0 : 1);
  }, [compData.general_type]);

  const updateItem = (newData, type) => {
    let newCompData = { ...compData };
    if (type) {
      newCompData[type] = { ...compData[type], ...newData };
    } else {
      newCompData = { ...compData, ...newData };
    }
    setCompData(newCompData);
    // const defaultData = {...emptyItem.current};
    // setCompData({ ...defaultData });
    onUpdate(newCompData);
  }

  const showComponent = (tab) => {
    let component;
    switch (tab) {
      case 'general_hero':
        component = <HeroBanner data={compData[tab]} type={tab} updateFullCompData={updateItem} />
        break;
      case 'general_triple':
        component = <Triple data={compData[tab]} type={tab} updateFullCompData={updateItem} />
        break;
      default:
    }
    return component;
  }

  return (
    <React.Fragment>
      <div className="form-message">
        {labels.pagesManagement.marketingBanner.marketing_banner} - {labels.pagesManagement.forms.hero_marketing_banner}
      </div>
      <div className="form-content">
        <div className="form-field">
          <RadioGroup data={[
            { label: labels.pagesManagement.forms.hero, value: 'hero' },
            { label: labels.pagesManagement.forms.triple, value: 'triple' }
          ]}
            layout='horizontal'
            value={compData.general_type}
            onChange={({ value }) => {
              updateItem({ general_type: value });
            }}
          />
        </div>
        <div className="form-tabs">
          {innerTabs.map((tab, i) => {
            return <div key={i} className={`form-inner ${contentSelect === i ? "form-inner--active" : ""}`} data-tab={i}>{showComponent(tab)}</div>
          })}
        </div>
        {/* <div style={{ marginTop: 20 }}>{JSON.stringify(compData)}</div> */}
      </div>
    </React.Fragment>
  );
};